export default __webpack_public_path__ + "static/media/1.627068e9.webp";